import React, { FC } from "react";
import { useIntl } from "react-intl";
import { Slider } from "antd";
import { Props, defaultData } from "./types";
import { messages } from "./messages";

const VerseTypographySettings: FC<Props> = ({ data = defaultData, setData }) => {
  const intl = useIntl();

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <label style={{ display: "block" }}>
        {intl.formatMessage(messages.verseFontSize)}
        <div style={{ marginTop: 6 }}>
          <Slider
            min={10}
            max={56}
            step={1}
            value={data.verseFontSize}
            onChange={(value) =>
              setData({
                ...data,
                verseFontSize: Number(value ?? defaultData.verseFontSize),
              })
            }
          />
        </div>
      </label>

      <label style={{ display: "block" }}>
        {intl.formatMessage(messages.verseFontWeight)}
        <div style={{ marginTop: 6 }}>
          <Slider
            min={100}
            max={900}
            step={100}
            value={data.verseFontWeight}
            onChange={(value) =>
              setData({
                ...data,
                verseFontWeight: Number(value ?? defaultData.verseFontWeight),
              })
            }
          />
        </div>
      </label>

      <label style={{ display: "block" }}>
        {intl.formatMessage(messages.referenceFontSize)}
        <div style={{ marginTop: 6 }}>
          <Slider
            min={6}
            max={36}
            step={1}
            value={data.referenceFontSize}
            onChange={(value) =>
              setData({
                ...data,
                referenceFontSize: Number(value ?? defaultData.referenceFontSize),
              })
            }
          />
        </div>
      </label>

      <label style={{ display: "block" }}>
        {intl.formatMessage(messages.referenceFontWeight)}
        <div style={{ marginTop: 6 }}>
          <Slider
            min={100}
            max={900}
            step={100}
            value={data.referenceFontWeight}
            onChange={(value) =>
              setData({
                ...data,
                referenceFontWeight: Number(value ?? defaultData.referenceFontWeight),
              })
            }
          />
        </div>
      </label>
    </div>
  );
};

export default VerseTypographySettings;
